import { useState, useEffect } from "react";
import Mower from "./Mower";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const MowerContainer = (props:any) => {
  const managedMowerRef = props?.managedMowerRef;
  const dispatch = useDispatch();

  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [deckSizeDropDownList, setDeckSizeDropDownList] = useState<any>([]);
  const [deckTypeDropDownList, setDeckTypeDropDownList] = useState<any>([]);
  const [annualHoursDropDownList, setAnnualHoursDropDownList] = useState<any>([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState<any>([]);
  const [stateAvailabilityDropDownList, setstateAvailabilityDropDownList] = useState<any>([]);
  const [programStatusDropDownList, setProgramStatusDropDownList] = useState<any>([]);
  const [autonomousDropDownList, setAutonomousDropDownList] = useState<any>([]);

  const {managedEquipmentDropDown,managedEquipmentValues, editRequestDetails, isEditRequestClick}: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultCategoryOption = {
            text: "Select Category",
            value: null
        };
        item?.dropdownList?.unshift(defaultCategoryOption);
        let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        }else if (item?.dropdownName == "Deck Size") {
          const defaultDeckSizeOption = {
            text: "Select Deck Size",
            value: null
        };
        item?.dropdownList?.unshift(defaultDeckSizeOption);
        let deckSizeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setDeckSizeDropDownList(deckSizeDropdownListTemp)
        }else if (item?.dropdownName == "Deck Type") {
          const defaultDeckTypeOption = {
            text: "Select Deck Type",
            value: null
        };
        item?.dropdownList?.unshift(defaultDeckTypeOption);
        let deckTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setDeckTypeDropDownList(deckTypeDropdownListTemp)
        }else if (item?.dropdownName == "State Availability") {
          const defaultStateAvailabilityOption = {
            text: "Select State Availability",
            value: null
        };
        item?.dropdownList?.unshift(defaultStateAvailabilityOption);
        let stateAvailabilityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setstateAvailabilityDropDownList(stateAvailabilityDropdownListTemp)
        }else if (item?.dropdownName == "Program Status") {
          const defaultProgramStatusOption = {
            text: "Select Program Status",
            value: null
        };
        item?.dropdownList?.unshift(defaultProgramStatusOption);
        let programStatusDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setProgramStatusDropDownList(programStatusDropdownListTemp)
        }else if (item?.dropdownName == "Annual Hours") {
          const defaultAnnualHoursOption = {
            text: "Select Annual Hours",
            value: null
        };
        item?.dropdownList?.unshift(defaultAnnualHoursOption);
        let annualHoursDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setAnnualHoursDropDownList(annualHoursDropdownListTemp)
        }else if (item?.dropdownName == "Autonomous") {
          const defaultAutonomousOption = {
            text: "Select Autonomous",
            value: null
        };
        item?.dropdownList?.unshift(defaultAutonomousOption);
        let autonomousDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setAutonomousDropDownList(autonomousDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(()=> {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedStateAvailability: any = ""
      let selectedManufacturer: any = ""
      let selectedProgramStatus: any = ""
      let selectedAnnualHours: any = ""
      let selectedCategory: any = ""
      let selectedDeckSize: any = ""
      let selectedDeckType: any = ""
      let selectedAutonomous: any = ""

      if (editRequestDetails?.stateAvailability && stateAvailabilityDropDownList?.length > 0) {
        selectedStateAvailability = stateAvailabilityDropDownList?.find((option: any) => option?.value === editRequestDetails?.stateAvailability)
      }
      
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((option: any) => option?.value === editRequestDetails?.manufacturer)
      }
      
      if (editRequestDetails?.programStatus && programStatusDropDownList?.length > 0) {
        selectedProgramStatus = programStatusDropDownList?.find((option: any) => option?.value === editRequestDetails?.programStatus)
      }

      if (editRequestDetails?.annualHours && annualHoursDropDownList?.length > 0) {
        selectedAnnualHours = annualHoursDropDownList?.find((option: any) => option?.value === editRequestDetails?.annualHours)
      }

      if (editRequestDetails?.category && categoryDropdownList?.length > 0) {
        selectedCategory = categoryDropdownList?.find((option: any) => option?.value === editRequestDetails?.category)
      }

      if (editRequestDetails?.deckSize && deckSizeDropDownList?.length > 0) {
        selectedDeckSize = deckSizeDropDownList?.find((option: any) => option?.value === editRequestDetails?.deckSize)
      }

      if (editRequestDetails?.deckType && deckTypeDropDownList?.length > 0) {
        selectedDeckType = deckTypeDropDownList?.find((option: any) => option?.value === editRequestDetails?.deckType)
      }

      if (editRequestDetails?.autonomous && autonomousDropDownList?.length > 0) {
        selectedAutonomous = autonomousDropDownList?.find((option: any) => option?.value === editRequestDetails?.autonomous)
      }

      managedEquipmentValuesTemp = { 
        ...managedEquipmentValues, 
        stateAvailability: selectedStateAvailability,
        manufacturer: selectedManufacturer, 
        programStatus: selectedProgramStatus,
        annualHours: selectedAnnualHours,
        category: selectedCategory,
        deckSize: selectedDeckSize,
        deckType: selectedDeckType,
        autonomous: selectedAutonomous
      }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, deckSizeDropDownList, deckTypeDropDownList, annualHoursDropDownList, categoryDropdownList, stateAvailabilityDropDownList, programStatusDropDownList, autonomousDropDownList])

const handleAvailabilityChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
 if(item !== 'Select State Availability') {
  managedMowerRef.current[2]?.focus()
 }
}

const handleManufacturerChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Manufacturer') {
    managedMowerRef.current[3]?.focus()
  }
}

const handleProgramStatusChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Program Status') {
    managedMowerRef.current[4]?.focus()

  }
}

const handleAnnualHoursChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Annual Hours') {
    managedMowerRef.current[5]?.focus()

  }
}

const handleCategeoryChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Category') {
    managedMowerRef.current[6]?.focus()

  }
}

const handleDeckSizeChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Deck Size') {
    managedMowerRef.current[7]?.focus()

  }
}

const handleDeckTypeChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Deck Type') {
    managedMowerRef.current[7]?.focus()

  }
}

const handleAutonomousChanges = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item !== 'Select Autonomous') {
    managedMowerRef.current[8]?.focus()

  }
}

useEffect(()=> {
  managedMowerRef.current[1]?.focus()
},[])

  return (
    <Mower
      managedEquipmentValues={managedEquipmentValues}
      manufacturerDropDownList={manufacturerDropDownList}
      categoryDropdownList={categoryDropdownList}
      deckSizeDropDownList={deckSizeDropDownList}
      deckTypeDropDownList={deckTypeDropDownList} 
      stateAvailabilityDropDownList={stateAvailabilityDropDownList}
      annualHoursDropDownList={annualHoursDropDownList}
      autonomousDropDownList={autonomousDropDownList}
      programStatusDropDownList={programStatusDropDownList}
      managedMowerRef={managedMowerRef}
      handleAvailabilityChanges={handleAvailabilityChanges}
      handleManufacturerChanges={handleManufacturerChanges}
      handleProgramStatusChanges={handleProgramStatusChanges}
      handleAnnualHoursChanges={handleAnnualHoursChanges}
      handleCategeoryChanges={handleCategeoryChanges}
      handleDeckSizeChanges={handleDeckSizeChanges}
      handleAutonomousChanges={handleAutonomousChanges}
      handleDeckTypeChanges = {handleDeckTypeChanges}
    />
  )
}

export default MowerContainer;
